import { render, staticRenderFns } from "./platformAdmin.vue?vue&type=template&id=730d8fb3&scoped=true&"
import script from "./platformAdmin.vue?vue&type=script&lang=js&"
export * from "./platformAdmin.vue?vue&type=script&lang=js&"
import style0 from "./platformAdmin.vue?vue&type=style&index=0&id=730d8fb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d8fb3",
  null
  
)

export default component.exports